import React from 'react'
import { Link } from 'react-router-dom'
import { Avatar, Menu } from 'antd'
import { Icon as LegacyIcon } from '@ant-design/compatible'
import { LogoutOutlined } from '@ant-design/icons'
import styles from './TopBar.module.scss'
import { useComponentLocale } from '../hooks/useComponentLocale'
import { KeyIcon, SettingsIcon } from '../helpers/icons'
import classNames from 'classnames'
import AddKeyModal from '../Library/Subscription/AddKeyModal/AddKeyModal'
import { useDispatch } from 'react-redux'
import { keyConstants } from '../Redux/_reducers'

function UserProfile({ onLogout, userName, ...props }) {
	const getLocale = useComponentLocale()
	const settingLocale = getLocale({ component: 'common_buttons', section: 'settings' })
	const logoutLocale = getLocale({ component: 'common_buttons', section: 'logout' })
	const dispatch = useDispatch()

	const onOpenKeyModal = () => {
		dispatch({ type: keyConstants.APPLY_KEY_SHOW })
	}

	return (
		<>
			<Menu.SubMenu
				title={
					<Avatar
						shape='square'
						icon={<LegacyIcon type='user' />}
						style={{ width: 40, height: 40, backgroundColor: 'var(--additional-surface)' }}
					/>
				}
				className={styles.submenuAvatar}
				{...props}
			>
				<Menu.ItemGroup title={<span className={styles.userNameContainer}>{userName}</span>}>
					<Menu.Item key='settings' className={classNames(styles.menuItem, styles.subMenuItem)}>
						<Link to='/settings/subscriptions' className={styles.subMenuLinks}>
							<span>
								<SettingsIcon className={styles.settingsIcon} />
								<span className={styles.menuTitle}>{settingLocale}</span>
							</span>
						</Link>
					</Menu.Item>
					<Menu.Item key='Key' onClick={onOpenKeyModal} className={classNames(styles.menuItem, styles.subMenuItem)}>
						<span className={styles.subMenuLinks}>
							<KeyIcon className={styles.settingsIcon} />
							<span>Apply key</span>
						</span>
					</Menu.Item>
					<Menu.Item key='Logout' onClick={onLogout} className={classNames(styles.menuItem, styles.subMenuItem)}>
						<span className={styles.subMenuLinks}>
							<LogoutOutlined />
							<span>{logoutLocale}</span>
						</span>
					</Menu.Item>
				</Menu.ItemGroup>
			</Menu.SubMenu>
			{/* Modal with Add Key Interface*/}
			<AddKeyModal />
		</>
	)
}

export default React.memo(UserProfile)
